import { render, staticRenderFns } from "./o-contact-leads.vue?vue&type=template&id=3583d32c"
import script from "./o-contact-leads.vue?vue&type=script&lang=js"
export * from "./o-contact-leads.vue?vue&type=script&lang=js"
import style0 from "./o-contact-leads.vue?vue&type=style&index=0&id=3583d32c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports